(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {

    var drawer    = document.getElementById('cart-drawer');
    var overlay   = document.getElementById('global-overlay');
    if (!drawer) return;

    var bodyEl        = drawer.querySelector('[data-drawer-body]');
    var itemsEl       = drawer.querySelector('[data-drawer-items]');
    var footerEl      = drawer.querySelector('[data-drawer-footer]');
    var subtotalEl    = drawer.querySelector('[data-drawer-subtotal]');
    var countBadge    = drawer.querySelector('[data-drawer-cart-count]');
    var headerCount   = document.querySelector('[data-cart-count]');

    // ── Open / Close ──────────────────────────────────────────────────────
    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      overlay.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
      // refresh cart from server
      refreshCart();
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      overlay.classList.remove('is-visible');
      document.body.style.overflow = '';
    }

    // Toggle triggers (cart icon in header)
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-drawer-toggle]')) {
        e.preventDefault();
        openDrawer();
      }
      if (e.target.closest('[data-cart-drawer-close]')) {
        closeDrawer();
      }
    });

    // Close on overlay click
    overlay.addEventListener('click', function () {
      if (drawer.classList.contains('is-open')) closeDrawer();
    });

    // Quick-buy (collection page "Select options" sheet) adds via fetch and
    // dispatches this event instead of submitting a form, so nothing below
    // catches it. Open the drawer so the shopper sees the item land (2026-09-13).
    document.addEventListener('cart:updated', function () {
      openDrawer();
    });

    // Close on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    // ── i18n strings (from data-* on drawer) ──────────────────────────────
    var i18nDecQty   = drawer.dataset.i18nDecreaseQty   || 'Decrease quantity';
    var i18nIncQty   = drawer.dataset.i18nIncreaseQty   || 'Increase quantity';
    var i18nQty      = drawer.dataset.i18nQuantity      || 'Quantity';
    var i18nRemove   = drawer.dataset.i18nRemove        || 'Remove';
    var i18nEmpty    = drawer.dataset.i18nEmpty         || 'Your cart is empty.';
    var i18nContinue = drawer.dataset.i18nContinueShopping || 'Continue shopping';

    // ── Money formatter ───────────────────────────────────────────────────
    function formatMoney(cents) {
      return window.Theme.formatMoney(cents);
    }

    // ── Refresh cart from server ──────────────────────────────────────────
    async function refreshCart() {
      try {
        bodyEl.style.opacity = '0.5';
        var res  = await fetch('/cart.js');
        var cart = await res.json();
        renderCart(cart);
      } catch (err) {
        console.error('Cart fetch error:', err);
      } finally {
        bodyEl.style.opacity = '';
      }
    }

    // ── Free-shipping progress (reference .free-bar) ──────────────────────
    var freeshipEl   = drawer.querySelector('[data-freeship]');
    var freeshipText = drawer.querySelector('[data-freeship-text]');
    var freeshipFill = drawer.querySelector('[data-freeship-fill]');

    function updateFreeship(subtotalCents, itemCount) {
      if (!freeshipEl) return;
      if (!itemCount) { freeshipEl.hidden = true; return; }
      freeshipEl.hidden = false;
      // Setting is in shop currency, cart totals are in presentment currency.
      var threshold = window.Theme.shopToPresentment(
        parseInt(freeshipEl.dataset.thresholdShop, 10) || 0
      );
      if (!threshold) return;
      var pct = Math.min(100, (subtotalCents / threshold) * 100);
      if (freeshipFill) freeshipFill.style.width = pct + '%';
      if (freeshipText) {
        if (subtotalCents >= threshold) {
          freeshipText.textContent = freeshipEl.dataset.i18nUnlocked;
        } else {
          // The translated string already wraps __AMOUNT__ in <b> tags
          freeshipText.innerHTML = freeshipEl.dataset.i18nRemaining
            .replace('__AMOUNT__', formatMoney(threshold - subtotalCents));
        }
      }
    }

    // In a converted currency the server left the bar blank, since Liquid has no
    // exchange rate. Fill it in now that window.Shopify.currency.rate is readable.
    if (freeshipEl && freeshipEl.hasAttribute('data-fx-pending')) {
      updateFreeship(
        parseInt(freeshipEl.dataset.subtotal, 10) || 0,
        parseInt(freeshipEl.dataset.itemCount, 10) || 0
      );
    }

    // ── Render cart items ─────────────────────────────────────────────────
    function renderCart(cart) {
      // update header badge
      updateCounts(cart.item_count);
      updateFreeship(cart.items_subtotal_price, cart.item_count);

      if (cart.item_count === 0) {
        itemsEl.innerHTML = '<div class="cart-drawer__empty" data-drawer-empty>'
          + '<div class="cart-drawer__empty-icon" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg></div>'
          + '<p class="cart-drawer__empty-text">' + i18nEmpty + '</p>'
          + '<a href="/collections/all" class="btn btn--primary btn--sm" data-cart-drawer-close>' + i18nContinue + '</a>'
          + '</div>';
        if (footerEl) footerEl.hidden = true;
        return;
      }

      if (footerEl) footerEl.hidden = false;
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.items_subtotal_price);

      // Build items HTML
      var html = cart.items.map(function (item) {
        var imgHtml = item.featured_image
          ? '<img src="' + item.featured_image.url + (item.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="' + (item.featured_image.alt || item.product_title) + '" width="80" height="107" loading="lazy">'
          : '<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 100 100" fill="#eee"><rect width="100" height="100"/></svg>';

        var variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
          ? '<p class="cart-drawer__item-variant">' + item.variant_title + '</p>'
          : '';

        var priceHtml = (item.original_price !== item.final_price)
          ? '<s class="price price--compare">' + formatMoney(item.original_price) + '</s> <span class="price price--sale">' + formatMoney(item.final_price) + '</span>'
          : formatMoney(item.final_line_price);

        return '<div class="cart-drawer__item" data-drawer-item data-item-key="' + item.key + '">'
          + '<a href="' + item.url + '" class="cart-drawer__item-img" tabindex="-1">' + imgHtml + '</a>'
          + '<div class="cart-drawer__item-info">'
          + '<a href="' + item.url + '" class="cart-drawer__item-title">' + item.product_title + '</a>'
          + variantHtml
          + '<div class="cart-drawer__item-row">'
          + '<div class="cart-drawer__qty" data-drawer-qty-selector>'
          + '<button type="button" class="cart-drawer__qty-btn" data-drawer-qty-minus aria-label="' + i18nDecQty + '">&minus;</button>'
          + '<input type="number" class="cart-drawer__qty-input" value="' + item.quantity + '" min="0" max="99" data-drawer-qty-input data-item-key="' + item.key + '" aria-label="' + i18nQty + '">'
          + '<button type="button" class="cart-drawer__qty-btn" data-drawer-qty-plus aria-label="' + i18nIncQty + '">&plus;</button>'
          + '</div>'
          + '<span class="cart-drawer__item-price" data-drawer-line-price>' + priceHtml + '</span>'
          + '</div>'
          + '</div>'
          + '<button class="cart-drawer__item-remove" data-drawer-remove data-item-key="' + item.key + '" aria-label="' + i18nRemove + '">'
          + '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'
          + '</button>'
          + '</div>';
      }).join('');

      itemsEl.innerHTML = html;
      bindItemEvents();
    }

    // ── Update cart count badges ──────────────────────────────────────────
    function updateCounts(count) {
      if (countBadge) countBadge.textContent = '(' + count + ')';
      if (headerCount) {
        headerCount.textContent = count;
        headerCount.classList.toggle('is-hidden', count === 0);
      }
    }

    // ── Cart AJAX update ──────────────────────────────────────────────────
    async function updateCart(key, quantity, itemRow) {
      try {
        itemRow.style.opacity = '0.5';
        itemRow.style.pointerEvents = 'none';
        var res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: quantity })
        });
        if (!res.ok) throw new Error('Cart update failed');
        var cart = await res.json();
        renderCart(cart);
      } catch (err) {
        console.error('Cart update error:', err);
        itemRow.style.opacity = '';
        itemRow.style.pointerEvents = '';
      }
    }

    function debounce(fn, ms) {
      var t;
      return function () { var a = arguments; clearTimeout(t); t = setTimeout(function () { fn.apply(null, a); }, ms); };
    }

    // ── Bind events on rendered items ─────────────────────────────────────
    function bindItemEvents() {
      itemsEl.querySelectorAll('[data-drawer-item]').forEach(function (row) {
        var key      = row.dataset.itemKey;
        var input    = row.querySelector('[data-drawer-qty-input]');
        var minus    = row.querySelector('[data-drawer-qty-minus]');
        var plus     = row.querySelector('[data-drawer-qty-plus]');
        var remove   = row.querySelector('[data-drawer-remove]');

        var debouncedUpdate = debounce(function (qty) { updateCart(key, qty, row); }, 400);

        minus && minus.addEventListener('click', function () {
          var v = Math.max(0, (parseInt(input.value) || 1) - 1);
          input.value = v;
          debouncedUpdate(v);
        });

        plus && plus.addEventListener('click', function () {
          var v = (parseInt(input.value) || 0) + 1;
          input.value = v;
          debouncedUpdate(v);
        });

        input && input.addEventListener('change', function () {
          var v = Math.max(0, parseInt(input.value) || 0);
          input.value = v;
          debouncedUpdate(v);
        });

        remove && remove.addEventListener('click', function () { updateCart(key, 0, row); });
      });
    }

    // ── Initial bind (server-rendered items) ─────────────────────────────
    bindItemEvents();

    // ── Intercept add-to-cart forms site-wide ────────────────────────────
    document.addEventListener('submit', async function (e) {
      var form = e.target.closest('form[action="/cart/add"]');
      if (!form) return;
      e.preventDefault();

      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Adding…';
      }

      try {
        var formData = new FormData(form);
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        });
        if (!res.ok) {
          var err = await res.json();
          alert(err.description || 'Could not add item to cart.');
          return;
        }
        await refreshCart();
        openDrawer();
      } catch (err) {
        console.error('Add to cart error:', err);
      } finally {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = submitBtn.dataset.originalText || 'Add to cart';
        }
      }
    });

    // Store original button text on load
    document.querySelectorAll('form[action="/cart/add"] [type="submit"]').forEach(function (btn) {
      btn.dataset.originalText = btn.textContent.trim();
    });

  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wishlist-btn]');
      if (!btn) return;
      btn.classList.toggle('is-saved');
      btn.setAttribute('aria-label',
        btn.classList.contains('is-saved') ? 'Saved' : 'Save'
      );
    });

    /* Color dots — swap the card image to the selected color's variant */
    document.addEventListener('click', function (e) {
      var dot = e.target.closest('[data-card-color-dot]');
      if (!dot) return;
      var card = dot.closest('.product-card');
      if (!card) return;
      var img = card.querySelector('.product-card__img--primary');
      if (img && dot.dataset.image) {
        if (img.src !== dot.dataset.image) {
          img.src = dot.dataset.image;
          img.removeAttribute('srcset');
        }
        /* Keep the hover swap working — point it at the selected colour's 2nd
           image (falls back to the colour's main image so it never flashes a
           different colour). */
        var sec = card.querySelector('.product-card__img--secondary');
        var wrap = card.querySelector('.product-card__img-wrap');
        if (sec) {
          sec.src = dot.dataset.image2 || dot.dataset.image;
          sec.removeAttribute('srcset');
          if (wrap) wrap.classList.add('product-card__img-wrap--has-secondary');
        }
      }
      card.querySelectorAll('.product-card__color-dot').forEach(function (d) {
        var active = d === dot;
        d.classList.toggle('is-active', active);
        d.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    });

    /* Quick-add AJAX — submit form without page reload */
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-quick-add-form]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('.product-card__quick-add-btn');
      var originalText = btn ? btn.innerHTML : '';
      if (btn) btn.innerHTML = 'Adding&hellip;';
      fetch(form.action, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
      .then(function (res) { return res.json(); })
      .then(function () {
        if (btn) {
          btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg> Added';
          setTimeout(function () { btn.innerHTML = originalText; }, 2000);
        }
        /* Refresh cart count badge if present */
        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(function () {
        if (btn) btn.innerHTML = originalText;
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-buy"] && !Shopify.designMode) return;
  try {
    (function () {
  var modal    = document.querySelector('[data-quick-buy-modal]');
  var closeBtn = document.querySelector('[data-quick-buy-close]');
  var body     = document.querySelector('[data-quick-buy-body]');

  if (!modal) return;

  function openModal() { modal.showModal(); }
  function closeModal() { modal.close(); }

  closeBtn?.addEventListener('click', closeModal);
  modal.addEventListener('click', function (e) {
    if (e.target === modal) closeModal();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.open) closeModal();
  });

  /* Listen for clicks on multi-variant quick-add links (they link to product) */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-quick-buy-trigger]');
    if (!link) return;
    e.preventDefault();
    loadProduct(link.dataset.quickBuyTrigger);
    openModal();
  });

  function loadProduct(url) {
    if (!body) return;
    var loadingLabel = (modal && modal.dataset.i18nLoading) || 'Loading';
    body.innerHTML = '<div class="quick-buy__loading"><span class="quick-buy__spinner" role="status" aria-label="' + loadingLabel + '"></span></div>';

    fetch(url + '?view=quick-buy-json', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
    .then(function (r) {
      /* Fallback: fetch the product JSON endpoint */
      var productUrl = url.split('?')[0];
      return fetch(productUrl + '.js');
    })
    .then(function (r) { return r.json(); })
    .then(function (product) { renderProduct(product); })
    .catch(function () {
      var msg = (modal && modal.dataset.i18nCouldNotLoad) || 'Could not load product.';
      body.innerHTML = '<p style="text-align:center;padding:var(--space-8);color:var(--color-muted)">' + msg + '</p>';
    });
  }

  function renderProduct(product) {
    if (!body) return;

    var imgSrc = product.featured_image
      ? product.featured_image.replace(/(\.\w+)(\?.*)?$/, '_400x$1')
      : '';
    var price = formatMoney(product.price);
    var comparePrice = product.compare_at_price_max > product.price
      ? '<span class="price price--compare">' + formatMoney(product.compare_at_price_max) + '</span>'
      : '';

    /* Build options */
    var optionsHtml = '';
    if (!product.has_only_default_variant) {
      product.options.forEach(function (opt, i) {
        /* /products/{handle}.js may return options as strings or as
           {name, position, values} objects depending on the storefront */
        var optName = typeof opt === 'string' ? opt : opt.name;
        var values = product.variants.reduce(function (acc, v) {
          var val = v.options[i];
          if (!acc.includes(val)) acc.push(val);
          return acc;
        }, []);

        var nameLower = optName.toLowerCase();
        var valuesHtml = values.map(function (val) {
          if (nameLower === 'color' || nameLower === 'colour') {
            var toneSlug = val.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
            var swatchBg = 'var(--swatch-tone-' + toneSlug + ', ' + val.toLowerCase().replace(/ /g,'') + ')';
            return '<button type="button" class="swatch" style="--swatch-bg:' + swatchBg + '" data-qb-option-index="' + i + '" data-qb-option-value="' + val + '" title="' + val + '" aria-label="' + val + '" aria-pressed="false"><span class="visually-hidden">' + val + '</span></button>';
          }
          return '<button type="button" class="option-btn" data-qb-option-index="' + i + '" data-qb-option-value="' + val + '" aria-pressed="false">' + val + '</button>';
        }).join('');

        optionsHtml += '<div class="quick-buy__option"><p class="quick-buy__option-label">' + optName + '</p><div class="quick-buy__option-values">' + valuesHtml + '</div></div>';
      });
    }

    body.innerHTML =
      '<form class="quick-buy__inner" data-qb-form data-product-url="' + product.url + '">' +
        '<div class="quick-buy__img-wrap">' +
          (imgSrc ? '<img src="' + imgSrc + '" alt="" class="quick-buy__img" loading="lazy" width="180" height="240">' : '') +
        '</div>' +
        '<div class="quick-buy__info">' +
          '<p class="quick-buy__title">' + product.title + '</p>' +
          '<div class="quick-buy__price">' + comparePrice + '<span class="price' + (comparePrice ? ' price--sale' : '') + '" data-qb-price>' + price + '</span></div>' +
          optionsHtml +
          '<button type="submit" class="btn btn--primary btn--full quick-buy__add-btn" data-qb-submit>' + (modal.dataset.i18nAddToCart || 'Add to cart') + '</button>' +
          '<p class="quick-buy__error" data-qb-error>' + (modal.dataset.i18nSelectAll || 'Please select all options.') + '</p>' +
        '</div>' +
      '</form>';

    /* Attach variant data */
    var form = body.querySelector('[data-qb-form]');
    if (form) form._variants = product.variants;

    /* body outlives each rendered product, so bind its delegated listeners
       once; binding per render made the Nth product opened add N units */
    if (body._qbBound) return;
    body._qbBound = true;

    /* Option button selection */
    body.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qb-option-index]');
      if (!btn) return;
      var idx = btn.dataset.qbOptionIndex;
      body.querySelectorAll('[data-qb-option-index="' + idx + '"]').forEach(function (b) {
        b.classList.remove('is-selected');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-selected');
      btn.setAttribute('aria-pressed', 'true');

      /* Reflect the selected variant: swap image and price when resolvable */
      var form = e.target.closest('[data-qb-form]');
      if (!form || !form._variants) return;
      var selected = {};
      form.querySelectorAll('[data-qb-option-index].is-selected').forEach(function (b) {
        selected[parseInt(b.dataset.qbOptionIndex)] = b.dataset.qbOptionValue;
      });
      var match = form._variants.find(function (v) {
        return Object.keys(selected).every(function (i) { return v.options[i] === selected[i]; });
      });
      if (!match) return;
      if (match.featured_image && match.featured_image.src) {
        var img = form.querySelector('.quick-buy__img');
        if (img) {
          img.src = match.featured_image.src.replace(/(\.\w+)(\?.*)?$/, '_400x$1');
        }
      }
      var priceEl = form.querySelector('[data-qb-price]');
      if (priceEl && typeof match.price === 'number') {
        priceEl.textContent = formatMoney(match.price);
      }
    });

    /* Submit */
    body.addEventListener('submit', function (e) {
      e.preventDefault();
      var form = e.target.closest('[data-qb-form]');
      if (!form) return;

      var variants = form._variants || [];
      var selectedOpts = {};
      form.querySelectorAll('[data-qb-option-index].is-selected').forEach(function (b) {
        selectedOpts[parseInt(b.dataset.qbOptionIndex)] = b.dataset.qbOptionValue;
      });

      /* Validate all options selected */
      var numOptions = form.querySelectorAll('.quick-buy__option').length;
      var errEl = form.querySelector('[data-qb-error]');
      if (Object.keys(selectedOpts).length < numOptions) {
        if (errEl) errEl.style.display = 'block';
        return;
      }
      if (errEl) errEl.style.display = 'none';

      var optValues = Object.values(selectedOpts);
      var variant = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === optValues[i]; });
      });

      if (!variant) { if (errEl) { errEl.textContent = 'Variant unavailable.'; errEl.style.display = 'block'; } return; }

      var submitBtn = form.querySelector('[data-qb-submit]');
      if (submitBtn) submitBtn.textContent = 'Adding\u2026';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variant.id, quantity: 1 })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (submitBtn) submitBtn.textContent = 'Added!';
        setTimeout(function () {
          closeModal();
          document.dispatchEvent(new CustomEvent('cart:updated'));
        }, 800);
      })
      .catch(function () {
        if (submitBtn) submitBtn.textContent = 'Error — try again';
      });
    });
  }

  function formatMoney(cents) {
    return window.Theme.formatMoney(cents);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-view"] && !Shopify.designMode) return;
  try {
    (function () {

    var modal    = document.getElementById('quick-view-modal');
    var innerEl  = modal && modal.querySelector('[data-quick-view-inner]');
    if (!modal) return;

    // ── Open ──────────────────────────────────────────────────────────────
    async function openQuickView(handle) {
      innerEl.innerHTML = '<div class="quick-view__loading"><div class="quick-view__spinner"></div></div>';
      modal.showModal();

      try {
        var res     = await fetch('/products/' + handle + '.js');
        var product = await res.json();
        renderProduct(product);
      } catch (err) {
        var msg = (modal && modal.dataset.i18nCouldNotLoad) || 'Could not load product.';
        innerEl.innerHTML = '<p style="padding:2rem;text-align:center;color:var(--color-muted)">' + msg + '</p>';
        console.error('Quick view error:', err);
      }
    }

    // ── Close ─────────────────────────────────────────────────────────────
    function closeModal() {
      modal.close();
    }

    modal.addEventListener('click', function (e) {
      // click on backdrop closes modal
      if (e.target === modal) closeModal();
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-quick-view-close]')) closeModal();
      if (e.target.closest('[data-quick-view-trigger]')) {
        e.preventDefault();
        var handle = e.target.closest('[data-quick-view-trigger]').dataset.productHandle;
        if (handle) openQuickView(handle);
      }
    });

    // ── Money formatter ───────────────────────────────────────────────────
    // Delegate to the theme-wide formatter so quick view matches the rest of the
    // storefront, including the currency code when that setting is on.
    function formatMoney(cents) {
      return window.Theme.formatMoney(cents);
    }

    // ── Render product ────────────────────────────────────────────────────
    function renderProduct(product) {
      var images     = product.images || [];
      var variants   = product.variants || [];
      var options    = product.options || [];
      var firstVar   = variants[0] || {};
      var currentVariantId = firstVar.id;

      // ── Image gallery HTML ──────────────────────────────────────────────
      var imgSrc = images[0] ? images[0].replace('.jpg', '_800x.jpg').replace('.png', '_800x.png').replace('.webp', '_800x.webp') : '';
      var imagesHtml = '<img class="quick-view__main-img" data-qv-main-img src="' + (imgSrc || '') + '" alt="' + product.title + '" width="800" height="1067">';
      var dotsHtml = '';
      if (images.length > 1) {
        dotsHtml = '<div class="quick-view__img-nav">'
          + images.slice(0, 5).map(function (src, i) {
            var imgLabel = (modal.dataset.i18nImageN || 'Image __N__').replace('__N__', (i + 1));
            return '<button class="quick-view__img-dot' + (i === 0 ? ' is-active' : '') + '" data-qv-dot="' + i + '" data-src="' + src.replace(/\.jpg|\.png|\.webp/, '_800x$&') + '" aria-label="' + imgLabel + '"></button>';
          }).join('')
          + '</div>';
      }

      // ── Price HTML ──────────────────────────────────────────────────────
      var priceHtml;
      if (firstVar.compare_at_price && firstVar.compare_at_price > firstVar.price) {
        priceHtml = '<s class="price price--compare">' + formatMoney(firstVar.compare_at_price) + '</s>'
          + '<span class="price price--sale" data-qv-price>' + formatMoney(firstVar.price) + '</span>';
      } else {
        priceHtml = '<span class="price" data-qv-price>' + formatMoney(firstVar.price) + '</span>';
      }

      // ── Options HTML ────────────────────────────────────────────────────
      var COLOR_NAMES = ['color', 'colour', 'couleur', 'farbe', 'color'];
      var optionsHtml = options.map(function (opt, optIndex) {
        var isColor = COLOR_NAMES.indexOf(opt.name.toLowerCase()) > -1;
        var firstValue = opt.values[0] || '';
        var label = '<label class="quick-view__option-label">' + opt.name + ': <em data-qv-opt-val="' + optIndex + '">' + firstValue + '</em></label>';

        if (isColor) {
          var swatches = opt.values.map(function (val, vi) {
            var toneSlug = val.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
            var css = 'var(--swatch-tone-' + toneSlug + ', ' + val.toLowerCase().replace(/\s+/g, '') + ')';
            return '<button class="quick-view__swatch' + (vi === 0 ? ' is-selected' : '') + '" data-qv-opt-btn="' + optIndex + '" data-value="' + val + '" style="--swatch-bg:' + css + '" title="' + val + '" aria-label="' + val + '"></button>';
          }).join('');
          return label + '<div class="quick-view__swatches">' + swatches + '</div>';
        } else {
          var sizeBtns = opt.values.map(function (val, vi) {
            return '<button class="quick-view__size-btn' + (vi === 0 ? ' is-selected' : '') + '" data-qv-opt-btn="' + optIndex + '" data-value="' + val + '">' + val + '</button>';
          }).join('');
          return label + '<div class="quick-view__size-btns">' + sizeBtns + '</div>';
        }
      }).join('');

      // ── Vendor ──────────────────────────────────────────────────────────
      var vendorHtml = product.vendor ? '<p class="quick-view__vendor">' + product.vendor + '</p>' : '';

      // ── Full HTML ───────────────────────────────────────────────────────
      innerEl.innerHTML = '<div class="quick-view__grid">'
        + '<div class="quick-view__images">' + imagesHtml + dotsHtml + '</div>'
        + '<div class="quick-view__info">'
        + vendorHtml
        + '<h2 class="quick-view__title">' + product.title + '</h2>'
        + '<div class="quick-view__price-row" data-qv-price-row>' + priceHtml + '</div>'
        + (optionsHtml ? '<div class="quick-view__options">' + optionsHtml + '</div>' : '')
        + '<form action="/cart/add" method="post">'
        + '<input type="hidden" name="id" data-qv-variant-id value="' + currentVariantId + '">'
        + '<input type="hidden" name="quantity" value="1">'
        + '<button type="submit" class="btn btn--primary btn--full quick-view__atc">' + (modal.dataset.i18nAddToCart || 'Add to cart') + '</button>'
        + '</form>'
        + '<a href="/products/' + product.handle + '" class="quick-view__view-link">' + (modal.dataset.i18nViewFullDetails || 'View full details →') + '</a>'
        + '</div>'
        + '</div>';

      // ── Bind image dots ─────────────────────────────────────────────────
      modal.querySelectorAll('[data-qv-dot]').forEach(function (dot) {
        dot.addEventListener('click', function () {
          var mainImg = modal.querySelector('[data-qv-main-img]');
          if (mainImg) mainImg.src = dot.dataset.src;
          modal.querySelectorAll('[data-qv-dot]').forEach(function (d) { d.classList.remove('is-active'); });
          dot.classList.add('is-active');
        });
      });

      // ── Bind option selectors ───────────────────────────────────────────
      var selectedOptions = options.map(function (opt) { return opt.values[0]; });

      modal.querySelectorAll('[data-qv-opt-btn]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var optIdx = parseInt(btn.dataset.qvOptBtn);
          var val    = btn.dataset.value;

          // Update selected state
          modal.querySelectorAll('[data-qv-opt-btn="' + optIdx + '"]').forEach(function (b) { b.classList.remove('is-selected'); });
          btn.classList.add('is-selected');

          // Update label
          var labelVal = modal.querySelector('[data-qv-opt-val="' + optIdx + '"]');
          if (labelVal) labelVal.textContent = val;

          // Track selection
          selectedOptions[optIdx] = val;

          // Find matching variant
          var matched = variants.find(function (v) {
            return v.options.every(function (o, i) { return o === selectedOptions[i]; });
          });

          // Update hidden input + price
          var idInput = modal.querySelector('[data-qv-variant-id]');
          if (idInput && matched) {
            idInput.value = matched.id;
            var priceEl = modal.querySelector('[data-qv-price]');
            if (priceEl) priceEl.textContent = formatMoney(matched.price);
          }

          // Mark unavailable options
          if (options.length > 1) {
            var otherOptIdx = optIdx === 0 ? 1 : 0;
            modal.querySelectorAll('[data-qv-opt-btn="' + otherOptIdx + '"]').forEach(function (b) {
              var testOptions = selectedOptions.slice();
              testOptions[otherOptIdx] = b.dataset.value;
              var avail = variants.find(function (v) {
                return v.options.every(function (o, i) { return o === testOptions[i]; }) && v.available;
              });
              b.classList.toggle('is-unavailable', !avail);
            });
          }
        });
      });

    }

  })();
  } catch(e) { console.error(e); }
})();

})();
